export const ReservationStateType = {
  ToDo: 'to_do',
  InProgress: 'in_progress',
  Cancel: 'cancel',
  Finished: 'finished',
  FinishedErrors: 'finished_errors',
  Pending: 'pending'
};

